import FJTextStyle from './FJTextStyle';
import FJShadows from './style/FJShadows';

class FJTextStyleEcho extends FJTextStyle {
    initStyles(props = {}) {
        const echo = new FJShadows({
            ...props,
            shadowList: [
                {
                    // 第二层 带阴影（视觉效果上）
                    ...props,
                    offset: 10,
                    angle: 90,
                    blur: 0,
                    color: '#B48EFF',
                    position: 'relative',
                },
                {
                    // 第一层 带阴影（视觉效果上）
                    ...props,
                    offset: 18,
                    angle: 90,
                    blur: 0,
                    color: '#B48EFF',
                    opacity: 40,
                    position: 'absolute',
                },
            ],
            position: 'relative',
        });
        this._styles = [echo];
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{offset: *, shadowColor: *, shadowColor1: *, direction: *}}
     */
    getAdjustInfo() {
        const echo = this._styles[0];
        const info = echo.shadowList[0];
        return {
            color: [info.color],
            offset: info.offset * 2,
            direction: info.angle,
        };
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        const echoInfo = this._styles[0];
        const shadowList = echoInfo.shadowList;

        if (info.color[0] !== '') {
            shadowList[0].color = info.color[0];
            shadowList[1].color = info.color[0];
        }

        if (info.offset !== '') {
            shadowList[0].offset = info.offset / 2;
            shadowList[1].offset = (info.offset / 2) * 2 - 2;
        }

        if (info.direction !== '') {
            shadowList[0].angle = info.direction;
            shadowList[1].angle = info.direction;
        }
        echoInfo.shadowList = [...shadowList];
    }
}

export default FJTextStyleEcho;
